import { FC } from "react";
import { useTranslation } from "react-i18next";
import { useRecoilValue } from "recoil";

import { EntitiesList, ErrorsDisplayContainer } from "@ryde/controls";
import { AuditLogContext, useAuditLogHistory } from "@ryde/redux";
import {
  IHistoryLogDrawerProps,
  IInjectedDrawerProps,
  isGlobalLoaderActiveSelector,
  normalizeErrors,
  PLURAL_KEY,
} from "@ryde/shared";

import { LayoutRightLoader, LayoutRightLoaderSlotStyled } from "../../../right";
import { BaseDrawer, DrawerHeaderWithSubtitle, SearchSection } from "../drawer";
import { HistoryLogDrawerContentStyled } from "./history-log-drawer.styled";

export const HistoryLogDrawer: FC<
  IHistoryLogDrawerProps & IInjectedDrawerProps
> = ({ onCloseDrawer, drawerNumber, id, entity }) => {
  const { t } = useTranslation();
  const isGlobalLoaderActive = useRecoilValue(isGlobalLoaderActiveSelector);
  const {
    auditLogs,
    filteredAuditLogs,
    loading,
    error,
    contextValue,
    searchSectionProps,
  } = useAuditLogHistory({ id, entity });

  return (
    <BaseDrawer onCloseDrawer={onCloseDrawer} drawerNumber={drawerNumber}>
      <AuditLogContext.Provider value={contextValue}>
        <DrawerHeaderWithSubtitle
          onCloseDrawer={onCloseDrawer}
          title={t("general.HISTORY")}
          subTitle={` (${t(`${entity}.${PLURAL_KEY}`)}) `}
        />
        {auditLogs.length > 0 && <SearchSection {...searchSectionProps} />}
        {error && !loading && (
          <ErrorsDisplayContainer
            marginLeft="22px"
            serverErrors={normalizeErrors(error, t)}
          />
        )}
        <HistoryLogDrawerContentStyled>
          {!loading && <EntitiesList entityListData={filteredAuditLogs} />}
          {loading && !isGlobalLoaderActive && (
            <LayoutRightLoaderSlotStyled>
              <LayoutRightLoader>{t("ui.LOADING")}...</LayoutRightLoader>
            </LayoutRightLoaderSlotStyled>
          )}
        </HistoryLogDrawerContentStyled>
      </AuditLogContext.Provider>
    </BaseDrawer>
  );
};
